

<template>
  <div>
    <CRow>
      <CCol sm="12">
          <CCard>
            <CCardHeader>
              <CIcon name="cil-grid"/> 先生管理
              <div class="card-header-actions">
                <a
                  class="card-header-action"
                  rel="noreferrer noopener"
                  target="_blank"
                >
                </a>
              </div>
            </CCardHeader>
            <CCardBody>
              <div class="d-flex justify-content-between align-items-center mb-3 mx-0">
                <div class="form-inline p-0">
                  <label class="mr-2">Filter:</label>
                  <input type="text" placeholder="type string..." class="form-control" v-model="searchKeyWord">
                </div>
                <div class="form-inline p-0">
                  <CButton color="info" class="mt-4" @click='showRecordModal({},0, "Create")'>新規作成</CButton>
                </div>
              </div>
              <CDataTable
                :hover="true"
                :striped="true"
                :items="items"
                :loading="isLoading"
                :fields="fields"
                :itemsPerPage="20"
                @update:table-filter-value="search"
              >
                <template #show_details="{item, index}">
                  <td class="py-2">
                    <CButton class="mr-2" color="dark" variant="outline" square size="sm" @click="showRecordModal(item, index)">編集</CButton>
                    <CButton class="mr-2" color="danger" variant="outline" square size="sm" @click="showDeleteModal(item, index)">削除</CButton>
                  </td>
                </template>
                <template #under-table>

                  <CCol sm="12" class="text-center">
                    <paginate
                      :page-count="meta.total_pages"
                      :prev-text="'前へ'"
                      :next-text="'次へ'"
                      :click-handler="paging"
                      :container-class="'pagination'">
                    </paginate>
                  </CCol>
                </template>

              </CDataTable>

            </CCardBody>
          </CCard>
      </CCol>
    </CRow>
    <CModal
      :title="modalModeTitle()"
      :color="modalModeCss()"
      :show.sync="recordModal"
    >
       <CRow class="form-box">
         <CCol sm="12">
           <label class="record-label pt-3">先生名</label>
           <CInput placeholder="先生名" v-model="record.name" :class="{ 'hasError': $v.record.name.$error }"/>

           <small v-if="$v.record.name.$error" class="errorLabel">学校名を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">email</label>
           <CInput placeholder="email" v-model="record.email" :class="{ 'hasError': $v.record.email.$error }" />
           <small v-if="$v.record.email.$error" class="errorLabel">郵便番号を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">権限</label>
            <CSelect
              placeholder="権限を選択"
              :class="{ 'hasError': $v.record.role.$error }"
              :options="roleType"
              :value.sync="record.role"
            />
           <small v-if="$v.record.role.$error" class="errorLabel">住所1を入れてください</small>
         </CCol>
         <CCol sm="12">
           <label class="record-label pt-3">役職</label>
           <CInput placeholder="役職" v-model="record.position" :class="{ 'hasError': $v.record.position.$error }"/>
           <small v-if="$v.record.position.$error" class="errorLabel">役職を入れてください</small>
         </CCol>
         <CCol sm="12" v-if="record.id == null">
           <label class="record-label pt-3">パスワード</label>
           <CInput placeholder="パスワード" v-model="record.password" :class="{ 'hasError': $v.record.password.$error }"/>
           <small v-if="$v.record.password.$error" class="errorLabel">パスワードを入れてください</small>
         </CCol>

         <CCol sm="12">
           <label class="record-label pt-3">所属学校</label>
           <CSelect
             placeholder="所属学校を選択してください"
             :class="{ 'hasError': $v.record.school_id.$error }"
             :options="schoolTypes"
             :value.sync="record.school_id"
           />
           <small v-if="$v.record.school_id.$error" class="errorLabel">所属学校を入れてください</small>
         </CCol>
       </CRow>

       <template #footer>
         <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
         <CButton size="sm" color="info" @click="updateItem(mode, itemIndex)">登録</CButton>
       </template>
    </CModal>

    <CModal
      title="削除しますか？"
      color="danger"
      :show.sync="deleteModal"
    >
      <div class="text-center">
        <p>この先生アカウントを削除しますか？？</p>
        <p>削除してしまうと復元することはできません</p>
      </div>
      <template #footer>
        <CButton size="sm" @click="hideDeleteModal()">キャンセル</CButton>
        <CButton size="sm" color="danger" @click="deleteItem()">削除</CButton>
      </template>
    </CModal>




  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import Paginate from 'vuejs-paginate'
import { mapGetters } from 'vuex';

export default {
  name: 'Home',
  components: {Paginate},
  data() {
    return {
      isLoading: false,
      mode: 'Create',
      recordModal: false,
      deleteModal: false,
      itemIndex: 0,
      record: {},
      items: [],
      filter_cs: [],
      filter_vs: [],
      industryTypes: [],
      page: 1,
      word: "",
      sort_column: "id",
      sort_asc: "desc",
      select_gender: '',
      select_status: '',
      meta: {},
      industries: {},
      schoolTypes:[],
      fields: [
        { key: 'name', label: "先生名"},
        { key: 'email', label: "email"},
        { key: 'position', label: "役職"},
        { key: 'role', label: "権限"},
        { key: 'school_id', label: "所属学校ID"},
        { key: 'school_name', label: "所属学校名"},
        { key: 'show_details', label: '',  _style: 'width:15%', sorter: false, filter: false},
      ],
      memberDic: {"associate_member": "仮登録", "no_deposite_member": "本登録(未入金)", "member": "本登録"},
      roleType:[
        {'value': 'admin', 'label': '管理者'},
        {'value': 'viewer', 'label': '閲覧者'},
      ],
      searchKeyWord: "",
      isSearching: false,
    }
  },
  validations: {
    record: {
      name: {required},
      email: {required},
      position: {required},
      role: {required},
      school_id: {required},
      password: {required},
    }
  },
  methods: {
    formatIndustry: function(d) {
      //var s = ""
      //d.split(",").forEach(i => {
      //  s += this.industries[i] + ","
      //})
      return d
    },
    formatDate: function(d) {
        return moment(d).format("YYYY/MM/DD")
    },
    formatBirthday: function(d) {
        return moment(d).format("YYYY/MM/DD")
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規先生追加" : "編集"
    },
    showRecordModal: function(i, index, mode="Edit") {
      this.recordModal = true
      this.record = i

      this.mode = mode
      this.itemIndex = index
      this.record = JSON.parse(JSON.stringify(i))
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    deleteItem: function() {
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers/" + this.record.id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.deleteModal = false
          this.items.splice(this.itemIndex, 1)
        }).catch(error => {
          this.hideDeleteModal()
          this.errorNotify(error.response)
        })
    },
    updateItem: function(mode="Create", index=0) {
      // this.$v.record.$touch();
      // if(this.$v.record.$error) return

      if(mode == "Create") {
        console.log(this.record)
        this.record.email = this.record.email.trim()
        axios
          .post(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers", {"teacher": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.recordModal = false
            this.items.unshift(response.data)
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } else {
        axios
          .patch(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers/" + this.record.id, {"teacher": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then((response) => {
            this.record = response.data
            this.recordModal = false
            this.$set(this.items, index, JSON.parse(JSON.stringify(this.record)))
          }).catch(error => {
            this.errorNotify(error.response)
          })
      }
    },
    paging: function(n) {
      if(this.isSearching) {
        axios
        .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers?page=" + n + "&key_word=" + encodeURIComponent(this.word) + "&page=" + n + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
            this.items = response.data.teachers
            this.meta = response.data.meta
        }).catch(error => {
            this.errorNotify(error.response)
        })
      } else {
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers?page=" + n, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.teachers
            this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      }  
    },
    search: function(key_word) {
      if(key_word != "") {
        this.isSearching = true;
        this.page = 1;
        this.word = key_word
        if(key_word == "-") {
          this.word = ""
        }
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers?&key_word=" + encodeURIComponent(this.word) + "&page=" + this.page + "&column=" + this.sort_column + "&direction=" + this.sort_asc, {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.teachers
            this.meta = response.data.meta
          }).catch(error => {
              this.errorNotify(error.response)
          })
      } else {
        this.isSearching = false;
        this.page = 1;
        axios
          .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers", {headers: {'Authorization': 'Bearer ' + this.idToken}})
          .then(response => {
            this.items = response.data.teachers
            this.meta = response.data.meta
          }).catch(error => {
            this.errorNotify(error.response)
          })
      } 
    },
  },
  watch: {
    searchKeyWord(newValue) {
      this.search(newValue)
    }
  },
  mounted() {
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/teachers", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.items = response.data.teachers
        this.meta = response.data.meta
      }).catch(error => {
        this.errorNotify(error.response)
      })

    axios
      .get(process.env.VUE_APP_API_ENDPOINT + "/api/mng/schools_all", {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        response.data.forEach(row =>{
          this.schoolTypes.push(
            {'value': row.id, 'label': row.name}
          )
        })
        this.school = response.data
      }).catch(error => {
        this.errorNotify(error.response)
      })
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>
